export enum Unit {
  BIN = 'BIN', // NL // AR
  CAM = 'CAM', // NL // TO
  CBG = 'CBG', // TO
  CEBR = 'CEBR', // AR
  CEDE = 'CEDE', // AR
  CEES = 'CEES', // AR
  CEIT = 'CEIT', // AR
  CEUK = 'CEUK', // AR
  CLE = 'CLE', // TO
  FATV = 'FATV', // TO
  FRGTS = 'FRGTS', // NL
  FROMM = 'FROMM', // NL
  GALA = 'GALA', // NL // TO
  GEO = 'GEO', // NL // TO
  NEON = 'NEON', // NL // TO
  NGE = 'NGE', // TO
  PECO = 'PECO', // NL // TO
  PFEM = 'PFEM', // NL // AR // TO
  PMO = 'PMO', // AR
  PTVS = 'PTVS', // NL // TO
  MAD = 'MAD', // TO
  SHG = 'SHG', // AR
  TRV = 'TRV', // NL
  VOICI = 'VOICI', // NL // TO
  HBZ = 'HBZ',
  CTM = 'CTM',
  TESTUNIT = 'TEST-UNIT', // TO

  TVS = 'TVS',
}

export enum CeriseUnit {
  CEBR = 'CEBR',
  CEDE = 'CEDE',
  CEES = 'CEES',
  CEIT = 'CEIT',
  CEUK = 'CEUK',
  FRGTS = 'FRGTS',
  FROMM = 'FROMM',
}

export function isUnit(maybeUnit: unknown): maybeUnit is Unit {
  return Object.entries(Unit).some(([, unit]) => unit === maybeUnit);
}

export function assertUnit(maybeUnit: unknown): Unit {
  if (!isUnit(maybeUnit)) {
    throw new Error(`The unit "${maybeUnit}" does not exist.`);
  }

  return maybeUnit;
}
